module.exports = __webpack_public_path__ + "static/BBC-5050-logo-3109040f24cecdcc4138c8dedb974632.png";